<template>
  <div class="flex flex-col items-stretch">
    <slot
      v-bind:faulty="error"
      v-bind:touch="touch"
    />
    
    <div v-if="error">
      <div class="error" v-for="[k, ec] of Object.entries(errorcheckers).filter(([k, ec]) => validation[k] === false)" :key="k">
        {{ec(validation)}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    validation: Object,
    errorcheckers: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    error() {
      return this.validation && this.validation.$error
    }
  },
  methods: {
    touch() {
      if(this.validation) {
        this.validation.$touch();
      }
    }
  }
}
</script>

<style>

</style>